<template>
  <v-snackbar
    v-model="visible"
    location="bottom start"
    timeout="-1"
    color="transparent"
    :elevation="1"
    content-class="pa-0"
    class="calendar-snackbar"
  >
    <v-card
      v-if="notification"
      rounded="xl"
      :elevation="12"
      class="pa-5 d-flex flex-column calendar-card"
      color="white"
      max-width="380"
    >
      <div class="d-flex align-start ga-3 mb-3">
        <div
          class="d-flex align-center justify-center rounded-circle flex-shrink-0"
          style="
            width: 48px;
            height: 48px;
            background: linear-gradient(135deg, #09b582 0%, #0080c5 100%);
          "
        >
          <v-icon color="white" size="28">{{ notification.icono }}</v-icon>
        </div>

        <div class="flex-grow-1 text-textDarken font-weight-bold text-h6 lh-sm">
          {{ notification.titulo }}
        </div>

        <v-btn
          icon="mdi-close"
          variant="plain"
          density="compact"
          size="small"
          class="flex-shrink-0 mt-n1 mr-n2"
          @click="cerrar"
        />
      </div>

      <p v-if="notification.texto1" class="text-body-1 mb-2 text-text">
        {{ notification.texto1 }}
      </p>
      <p v-if="notification.texto2" class="text-body-1 mb-2 text-text">
        {{ notification.texto2 }}
      </p>
      <p v-if="notification.texto3" class="text-body-1 mb-2 text-text">
        {{ notification.texto3 }}
      </p>

      <div class="d-flex align-center justify-space-between mt-3">
        <span
          v-if="notification.deadline"
          class="text-tertiary font-weight-bold text-body-1"
        >
          {{ notification.deadline }}
        </span>
        <v-btn
          color="secondary"
          variant="flat"
          rounded="lg"
          class="ml-auto"
          @click="cerrar"
        >
          {{ notification.boton }}
        </v-btn>
      </div>
    </v-card>
  </v-snackbar>
</template>

<script setup>
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";

const { t, te } = useI18n();

const LS_KEY_PREFIX = "CAL_NOTIF_DISMISSED_";

function getTodayKey() {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

const todayKey = getTodayKey();
const lsKey = LS_KEY_PREFIX + todayKey;

const hasNotification = te(`calendario-notificaciones.${todayKey}.titulo`);
const isDismissed =
  typeof window !== "undefined" && localStorage.getItem(lsKey) === "true";

const visible = ref(hasNotification && !isDismissed);

const notification = computed(() => {
  if (!hasNotification) return null;

  const base = `calendario-notificaciones.${todayKey}`;
  return {
    icono: t(`${base}.icono`),
    titulo: t(`${base}.titulo`),
    texto1: te(`${base}.texto1`) ? t(`${base}.texto1`) : null,
    texto2: te(`${base}.texto2`) ? t(`${base}.texto2`) : null,
    texto3: te(`${base}.texto3`) ? t(`${base}.texto3`) : null,
    deadline: te(`${base}.deadline`) ? t(`${base}.deadline`) : null,
    boton: t(`${base}.boton`),
  };
});

function cerrar() {
  visible.value = false;
  localStorage.setItem(lsKey, "true");
}
</script>

<style>
.calendar-snackbar .v-snackbar__wrapper {
  background: transparent !important;
  box-shadow: none !important;
}

.calendar-card {
  position: relative;
  overflow: hidden;
}

.calendar-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: linear-gradient(90deg, #0080c5 46.63%, #09b582 100%);
}
</style>
